import useUserQuery from "../components/Common/useUserQuery";
import { QueryOptions } from "../components/Common/useQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface ProductConfigurationReportDto {
  product: string;
  sites: string;
  density: string;
}

export interface ProductConfigurationReportParams {
  siteId?: string;
  productId?: string;
}

const useGetProductConfigurationReport = (
  params: ProductConfigurationReportParams,
  options?: QueryOptions<ProductConfigurationReportDto[]>
) => {
  const business = useSelectedBusiness();
   
  return useUserQuery<ProductConfigurationReportDto[]>({
    path: formatProductConfigurationReportQuery(business.id, params),
  }, {
    autoQuery: false,
    ...options
  });
}

export const formatProductConfigurationReportQuery = (businessId: string, params: ProductConfigurationReportParams, download: boolean = false) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, value.toString());
    }
  });

  var path = `/api/businesses/${businessId}/reports/productConfiguration`;

  if (download) {
    path = path.concat("/download");
  }
 
  return `${path}?${urlParams.toString()}`;
}

export default useGetProductConfigurationReport;
